window.Products.DeviceCase.GalaxyS7Edge = function() {
};
window.Products.DeviceCase.GalaxyS7Edge.inherits(window.Products.DeviceCase.DeviceCase);
window.Products.DeviceCase.GalaxyS7Edge.id = 53;
window.Products.DeviceCase.GalaxyS7Edge.slug = 'galaxy-s7-edge';